module.exports = __webpack_public_path__ + "img/wsp.4edd4cab.svg";